export const LANDING = '/';
export const LOGIN = '/login';
export const SIGNOUT = '/signout';
export const COLLECTION = '/collections/:collectionId';
export const APP = '/collections/:collectionId/apps/:appName';
export const MEMBERSHIP = '/collections/:collectionId/membership';
export const SETTINGS = '/collections/:collectionId/settings';
export const USERCOLLECTIONS = '/users/:userId/collections';
export const INVITE = '/invites/:inviteId';
